import { render } from "./wangEditor.vue?vue&type=template&id=77aa36e0"
import script from "./wangEditor.vue?vue&type=script&lang=js"
export * from "./wangEditor.vue?vue&type=script&lang=js"

import "./wangEditor.vue?vue&type=style&index=0&id=77aa36e0&lang=scss"

import exportComponent from "/root/workspace/public_sso_CS39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__